import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ATTEMPT_TYPES = `${TASK_SERVICE}/assignment-types`;

export const attemptTypes = {
  getHoldReasons: async ({ typeId }) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}/${typeId}/reasongroups/holdreasons`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  getAll: async ({ filters, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  },
  get: async (id) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },

  /**
   * Creates a new attempt type.
   *
   * @param {Object} params - The parameters for the request.
   * @param {Object} params.data - The data to be sent in the request body.
   * @param {string} params.data.name - The name of the attempt type.
   * @param {string} params.data.shortName - The short name of the attempt type.
   * @param {string} [params.data.color] - The optional color of the attempt type.
   * @param {Object} [params.toastMessageConfig] - Optional configuration for toast messages.
   * @returns {Promise<Object>} - A promise that resolves to the response from the API request.
   *
   * @async
   */
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_ATTEMPT_TYPES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  /**
   * Updates an existing attempt type.
   *
   * @param {Object} params - The parameters for the request.
   * @param {string} params.id - The ID of the attempt type to be updated.
   * @param {Object} params.data - The data to be sent in the request body.
   * @param {string} params.data.name - The name of the attempt type.
   * @param {string} params.data.shortName - The short name of the attempt type.
   * @param {string} params.data.color - The color of the attempt type.
   * @param {Object} [params.toastMessageConfig] - Optional configuration for toast messages.
   * @returns {Promise<Object>} - A promise that resolves to the response from the API request.
   *
   * @async
   */
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  getApproveReasons: async ({ attemptTypeId }) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT_TYPES}/${attemptTypeId}/reasongroups/ApproveRescheduleReasons`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
